// extracted by mini-css-extract-plugin
export default {"products":"Qv-z","card":"Rv-z","oosMessaging":"Sv-z"};